module.exports = __webpack_public_path__ + "assets/img/sy.2325d337.png";